import { render, staticRenderFns } from "./customer-title.vue?vue&type=template&id=7e73b2a8"
import script from "./customer-title.vue?vue&type=script&lang=js"
export * from "./customer-title.vue?vue&type=script&lang=js"
import style0 from "./customer-title.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsUiIcon: require('/home/node/app/components/elements/ui-icon/ui-icon.vue').default,ElementsUiLink: require('/home/node/app/components/elements/ui-link/ui-link.vue').default,ElementsTextHeading: require('/home/node/app/components/elements/text-heading/text-heading.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
